import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaLeaf, FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const { i18n } = useTranslation();
  const isHindi = (i18n.language || 'hi') === 'hi';

  return (
    <footer className="fd-footer">
      <div className="fd-footer-inner">
        {/* Top / Main Row */}
        <div className="fd-footer-main">
          {/* Logo & Tagline */}
          <div className="fd-footer-brand">
            <div className="fd-footer-logo">
              <div className="fd-footer-icon">
                <FaLeaf />
              </div>
              <div className="fd-footer-logo-text">
                <span className="fd-footer-title">Fasal Drishti</span>
                <span className="fd-footer-sub">Detect • Explain • Act</span>
              </div>
            </div>
            <p className="fd-footer-desc">
              {isHindi 
                ? 'किसानों को AI-आधारित जानकारी से सशक्त बनाकर डिस्ट्रेस को रोकना और बेहतर कल का निर्माण करना।'
                : 'Empowering farmers with AI-driven insights to prevent distress and build a better tomorrow.'}
            </p>
          </div>

          {/* Navigation Links */}
          <div className="fd-footer-links-group">
            <a href="#about">{isHindi ? 'हमारे बारे में' : 'About Us'}</a>
            <a href="#privacy">{isHindi ? 'गोपनीयता नीति' : 'Privacy Policy'}</a>
            <a href="#terms">{isHindi ? 'नियम और शर्तें' : 'Terms & Conditions'}</a>
            <a href="#contact">{isHindi ? 'संपर्क करें' : 'Contact Us'}</a>
          </div>

          {/* Social Icons */}
          <div className="fd-footer-socials">
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="fd-social-link" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" className="fd-social-link" aria-label="Twitter"><FaTwitter /></a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="fd-social-link" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" className="fd-social-link" aria-label="YouTube"><FaYoutube /></a>
            <a href="https://whatsapp.com" target="_blank" rel="noreferrer" className="fd-social-link" aria-label="WhatsApp"><FaWhatsapp /></a>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="fd-footer-bottom">
          <p>© 2026 Fasal Drishti. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
